/**
 * @flow
 * @relayHash babfbd46aa667929d01870f5a954da00
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MediaGalleryList_viewer$ref = any;
export type MediaFileStateType = "available" | "deleted" | "%future added value";
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
export type MediaGalleryList_Refetch_QueryVariables = {|
  page: number,
  topic?: ?string,
  searchText?: ?string,
  show?: ?string,
  types?: ?$ReadOnlyArray<?MediaFileTypeEnum>,
  sort?: ?string,
  states?: ?$ReadOnlyArray<?MediaFileStateType>,
|};
export type MediaGalleryList_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: MediaGalleryList_viewer$ref
  |}
|};
export type MediaGalleryList_Refetch_Query = {|
  variables: MediaGalleryList_Refetch_QueryVariables,
  response: MediaGalleryList_Refetch_QueryResponse,
|};
*/


/*
query MediaGalleryList_Refetch_Query(
  $page: Int!
  $topic: ID
  $searchText: String
  $show: String
  $types: [MediaFileTypeEnum]
  $sort: String
  $states: [MediaFileStateType]
) {
  viewer {
    ...MediaGalleryList_viewer_3vol8A
    id
  }
}

fragment MediaGalleryList_viewer_3vol8A on Viewer {
  mediaFiles: mediaFilesPaginate(pageSize: 21, page: $page, topic: $topic, searchText: $searchText, show: $show, types: $types, sort: $sort, states: $states) {
    totalCount
    mediaFiles {
      id
      title
      filename
      description
      alt
      show
      topics {
        id
      }
      type
      preview
      status
      updatedAt
      seoTitle
      seoDescription
      seoKeywords
      slug
    }
  }
  topics: topics(first: -1) {
    edges {
      node {
        id
        name
      }
    }
  }
  ...TopicSelector_viewer
}

fragment TopicSelector_viewer on Viewer {
  topicsForSelector: topics(first: -1) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "topic",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "searchText",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "show",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "types",
    "type": "[MediaFileTypeEnum]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[MediaFileStateType]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": -1,
    "type": "Int"
  }
],
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "TopicEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Topic",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "MediaGalleryList_Refetch_Query",
  "id": null,
  "text": "query MediaGalleryList_Refetch_Query(\n  $page: Int!\n  $topic: ID\n  $searchText: String\n  $show: String\n  $types: [MediaFileTypeEnum]\n  $sort: String\n  $states: [MediaFileStateType]\n) {\n  viewer {\n    ...MediaGalleryList_viewer_3vol8A\n    id\n  }\n}\n\nfragment MediaGalleryList_viewer_3vol8A on Viewer {\n  mediaFiles: mediaFilesPaginate(pageSize: 21, page: $page, topic: $topic, searchText: $searchText, show: $show, types: $types, sort: $sort, states: $states) {\n    totalCount\n    mediaFiles {\n      id\n      title\n      filename\n      description\n      alt\n      show\n      topics {\n        id\n      }\n      type\n      preview\n      status\n      updatedAt\n      seoTitle\n      seoDescription\n      seoKeywords\n      slug\n    }\n  }\n  topics: topics(first: -1) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  ...TopicSelector_viewer\n}\n\nfragment TopicSelector_viewer on Viewer {\n  topicsForSelector: topics(first: -1) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MediaGalleryList_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MediaGalleryList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "searchText",
                "variableName": "searchText",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "show",
                "variableName": "show",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sort",
                "variableName": "sort",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "topic",
                "variableName": "topic",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "types",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MediaGalleryList_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "mediaFiles",
            "name": "mediaFilesPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 21,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "searchText",
                "variableName": "searchText",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "show",
                "variableName": "show",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "sort",
                "variableName": "sort",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[MediaFileStateType]"
              },
              {
                "kind": "Variable",
                "name": "topic",
                "variableName": "topic",
                "type": "ID"
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "types",
                "type": "[MediaFileTypeEnum]"
              }
            ],
            "concreteType": "mediaFilesPaginate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaFiles",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "filename",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "alt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "show",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "topics",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Topic",
                    "plural": true,
                    "selections": [
                      v1
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "preview",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "seoTitle",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "seoDescription",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "seoKeywords",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "slug",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "topics",
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": v2,
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": v3
          },
          {
            "kind": "LinkedField",
            "alias": "topicsForSelector",
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": v2,
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": v3
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '502770933a9a75d1e9702e1b4441c726';
module.exports = node;



// WEBPACK FOOTER //
// src/components/media/__generated__/MediaGalleryList_Refetch_Query.graphql.js